import React, { useState } from 'react';
import { Link } from 'react-router-dom';


function TermsBody(props) {

    const [side, setSide] = useState([
        {id:1,title:'Introduction'},
        {id:2,title:'Definitions'},
        {id:3,title:'Eligibility'},
        {id:4,title:'User Responsibilities'},
        {id:5,title:'Subscriptions and Payments'},
        {id:6,title:'Intellectual Property'},
        {id:7,title:'Privacy Policy'},
        {id:8,title:'Limitation of Liability'},
        {id:9,title:'Termination'},
        {id:10,title:'Governing Law and Dispute Resolution'},
        {id:11,title:'Amendments'},
        {id:12,title:'Contact Information'},
        {id:13,title:'Acknowledgment'},
    ])

    const [active, setActive] = useState(1)

    const changeActive = (id) => {
        setActive(id)
        document.getElementById(id).scrollIntoView({behavior:'smooth'})
        
    }

    return (
        <div className='flex flex-col px-5 lg:px-10 mt-5 lg:mt-10 mb-10 lg:mb-20'>
            <div className='text-center text-[30px] lg:text-[48px] font-[500]'>Terms and Conditions</div>
            <div className='grid grid-cols-8 gap-x-10 mt-5 lg:mt-10'>
            <div className='hidden h-[540px] lg:flex col-span-2 rounded-[8px] py-5 px-3 flex flex-col bg-[#FBFBFB] border-[1px] border-[#E0E0E0] space-y-3'>
                {side.map(({id,title}) => {
                    return (
                        <span onClick={() => changeActive(id)} key={id} className={`cursor-pointer text-start font-[400] text-[16px] ${active == id ? 'text-[#008B39]' : 'text-[#737373]'}`}>{title}</span>
                    )
                })}
            </div>
            <div className='col-span-8 lg:col-span-6 flex flex-col text-[#424242] text-[16px] text-start space-y-2'>
                <div className='flex flex-col'>
                    <span>Terms and Conditions for Yebokenny App</span>
                    <span>Effective Date: 1st September, 2023</span>
                </div>
                <div id='1' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>1. Introduction</span>
                    <span>Welcome to Yebokenny App! By accessing or using our services, you agree to comply with
                        and be bound by these Terms and Conditions (&quot;Terms&quot;). Please read them carefully. These
                        Terms apply to all users and subscribers of Yebokenny App across all countries in Africa. If
                        you do not agree with these Terms, you must discontinue using the App immediately.
                    </span>
                </div>
                <div id='2' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>2. Definitions</span>
                    <span className='flex flex-col'>
                        <span>A. &quot;Yebokenny App&quot; refers to the mobile application, website, and related services
                        provided by Yebo Kenny Media Pty Ltd.</span>
                        <span>B. &quot;User&quot; refers to anyone accessing or using the App, including free and paid subscribers.</span>
                        <span>C. &quot;Subscriber&quot; refers to users who have subscribed to any paid services offered on the
                        App.</span>
                        <span>D. &quot;Content&quot; refers to all text, images, audio, video, software, and other materials available
                        on the App.</span>
                        <span>E. &quot;We,&quot; &quot;Our,&quot; &quot;Us&quot; refers to Yebo Kenny Media Pty Ltd, the owner and operator of
                        the Yebokenny App.</span>
                    </span>
                </div>
                <div id='3' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>3. Eligibility</span>
                    <span className='flex flex-col'>
                        <span>A. By using the App, you confirm that you are at least 18 years old or have
                        parental/guardian consent to use the App.</span>
                        <span>B. Use of the App is subject to compliance with all applicable laws and regulations in your
                        country.</span>
                    </span>
                </div>
                <div id='4' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>4. Third-Party Cookies</span>
                    <span className='font-[400] text-[#0E0E0E]'>4.1 User Responsibilities</span>
                    <span className='flex flex-col pl-2'>
                        <span>Account Registration: You must provide accurate and up-to-date information during
                        registration and keep your account secure.</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>4.2 Prohibited Activities: You agree not to:</span>
                    <span className='flex flex-col pl-2'>
                        <span>A. Use the App for illegal purposes.</span>
                        <span>B. Share, distribute, or upload harmful or unlawful content.</span>
                        <span>C. Attempt to hack, disable, or disrupt the App’s functionality.</span>
                        <span>D. Violate any intellectual property rights.</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>4.3 Compliance with Local Laws: You are responsible for ensuring that your use of the
                    App complies with local laws and regulations in your country.</span>
                </div>
                <div id='5' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>5. Subscriptions and Payments</span>
                    <span className='flex flex-col'>
                        <span>A. Subscription Plans: Yebokenny App offers various subscription plans. Details, pricing,
                        and benefits are outlined within the App.</span>
                        <span>B. Payments: Payments must be made using approved methods (e.g., credit cards, mobile
                            money).</span>
                        <span>C. Refund Policy: Subscription fees are non-refundable unless otherwise stated or required
                        by law.</span>
                        <span>D. Termination of Subscription: We reserve the right to terminate your subscription if
                        these Terms are violated.</span>
                    </span>
                </div>
                <div id='6' className='flex flex-col space-y-1'>
                <span className='font-[500] text-[#0E0E0E]'>6. Intellectual Property</span>
                    <span className='flex flex-col'>
                        <span>A. All content on Yebokenny App is owned or licensed by Yebo Kenny Media Pty Ltd and
                        is protected by copyright, trademark, and other intellectual property laws.</span>
                        <span>B. You may not reproduce, distribute, or create derivative works from the App’s content
                        without prior written permission.</span>
                    </span>
                </div>
                <div id='7' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>7. Privacy Policy</span>
                    <span className='flex flex-col'>
                        <span>A. By using the App, you agree to our Privacy Policy, which governs how we collect, use,
                        and store your data.</span>
                        <span>B. The Privacy Policy is accessible <Link className='underline text-[#008B39]' to="/privacy-policy">here.</Link> </span>
                    </span>
                </div>
                <div id='8' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>8. Limitation of Liability</span>
                    <span className='font-[400] text-[#0E0E0E]'>8.1 We provide the App &quot;as is&quot; and &quot;as available,&quot; without warranties of any kind.</span>
                    <span className='font-[400] text-[#0E0E0E]'>8.2 Yebo Kenny Media Pty Ltd is not liable for:</span>
                    <span className='flex flex-col pl-2'>
                        <span>A. Losses resulting from your use of the App.</span>
                        <span>B. Technical disruptions, including server outages or errors.</span>
                        <span>C. Third-party actions or content.</span>
                    </span>
                </div>
                <div id='9' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>9. Termination</span>
                    <span className='font-[400] text-[#0E0E0E]'>9.1 We may terminate or suspend your account at our discretion for breach of these Terms or
                    any applicable laws.</span>
                    <span className='font-[400] text-[#0E0E0E]'>9.2 You may discontinue using the App at any time by deleting your account.</span>
                </div>
                <div id='10' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>10. Governing Law and Dispute Resolution</span>
                    <span className='font-[400] text-[#0E0E0E]'>10.1 These Terms shall be governed by the laws of the Republic of South Africa.</span>
                    <span className='font-[400] text-[#0E0E0E]'>10.2 Disputes will be resolved through:</span>
                    <span className='flex flex-col pl-2'>
                        <span>A. Negotiation and mediation.</span>
                        <span>B. If unresolved, arbitration under the rules of Arbitration Foundation of Southern
                        Africa.</span>
                        <span>C. Users may seek remedies available under local consumer protection laws.</span>
                    </span>
                </div>
                <div id='11' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>11. Amendments</span>
                    <span className='font-[400] text-[#0E0E0E]'>11.1 We may update these Terms from time to time. Changes will be communicated through
                    the App or email. Continued use of the App constitutes acceptance of the revised Terms.</span>
                </div>
                <div id='12' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>12. Contact Us</span>
                    <span className='flex flex-col'>
                        <span>If you have any questions or concerns about these Terms, please contact us at:</span>
                        <span><span className='font-[500]'>Email: </span>Business@yebokenny.com</span>
                        <span><span className='font-[500]'>Phone: </span>+27 (0) 33 492 0174 / (0) 10 497 4633</span>
                        <span><span className='font-[500]'>Address: </span> 26 Kingsford Avenue, Kingston Park, Pietermaritzburg 3201, Kwazulu
                        Natal, South Africa.</span>
                    </span>
                </div>
                <div id='13' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>Acknowledgment</span>
                    <span className='flex flex-col'>
                        <span>By using Yebokenny App, you acknowledge that you have read, understood, and agreed to
                        this Privacy Policy.</span>
                    </span>
                </div>
            </div>
        </div>
        </div>

    );
}

export default TermsBody;